import { render, staticRenderFns } from "./button-component.vue?vue&type=template&id=73d6af6f&scoped=true"
import script from "./button-component.vue?vue&type=script&lang=js"
export * from "./button-component.vue?vue&type=script&lang=js"
import style0 from "./button-component.vue?vue&type=style&index=0&id=73d6af6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d6af6f",
  null
  
)

export default component.exports